import "../styles/registration.scss";
import { MultivalueInput } from "../components";
import { useEffect, useState } from "react";
import React from "react";
import { getCities, getMarks, getPriceSegments } from "./api";

export const RegistrationStep2 = React.forwardRef((props, ref) => {
    const { setIsFormValid, additionalData } = props;
    const [selectedCities, setSelectedCities] = useState([]);
    const [selectedMarks, setSelectedMarks] = useState([]);
    const [selectedPriceSegments, setSelectedPriceSegments] = useState([]);
    const [filtersData, setFiltersData] = useState({ marks: [], cities: [], priceSegments: [] });

    React.useImperativeHandle(ref, () => ({
        getData: () => {
            return {
                user: additionalData.id,
                filters: {
                    marks: selectedMarks.map(item => item.id),
                    cities: selectedCities.map(item => item.id),
                    priceSegments: selectedPriceSegments.map(item => item.id)
                }
            }
        }
    }));

    useEffect(() => {
        getMarks().then(data => {
            setFiltersData(prevFiltersData => ({
                ...prevFiltersData,
                marks: [{ id: 0, name: "Все" }, ...data]
            }));
        });
        getCities().then(data => {
            setFiltersData(prevFiltersData => ({
                ...prevFiltersData,
                cities: [{ id: 0, name: "Все" }, ...data]
            }));
        })
        getPriceSegments().then(data => {
            setFiltersData(prevFiltersData => ({
                ...prevFiltersData,
                priceSegments: [{ id: 0, name: "Все" }, ...data.map(item => ({
                    id: item.id,
                    name: `${item.min} ₽ - ${item.max} ₽`,
                    min: item.min,
                    max: item.max
                }))]
            }));
        })
        setIsFormValid(true);
    }, [setIsFormValid])

    const filterItems = (value, selectedElements) => {
        const selectedElementsHasAllElement = Array.from(selectedElements).find(item => item.id === 0)
        const hasAllElement = Array.from(value).find(item => item.id === 0);
        return hasAllElement && !selectedElementsHasAllElement ? [hasAllElement]: Array.from(value).filter(item => item.id !== 0) ;
    }

    const citiesChanged = (value) => {
        setSelectedCities(filterItems(value, selectedCities));
    }

    const marksChanged = (value) => {
        setSelectedMarks(filterItems(value, selectedMarks));
    }

    const priceSegmentsChanged = (value) => {
        setSelectedPriceSegments(filterItems(value, selectedPriceSegments));
    }

    return (
        <React.Fragment>
            <MultivalueInput className="registration__input-element" title="Города выкупа" elements={filtersData.cities} value={selectedCities} onChange={citiesChanged} />
            <MultivalueInput className="registration__input-element" title="Марки автомобилей" elements={filtersData.marks} value={selectedMarks} onChange={marksChanged} />
            <MultivalueInput className="registration__input-element" title="Ценовые сегменты" elements={filtersData.priceSegments} value={selectedPriceSegments} onChange={priceSegmentsChanged} />
        </React.Fragment>

    )
})